"use strict";

exports.__esModule = true;
exports.NotificationsIcon = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _NotificationsIcon = require("./NotificationsIcon.legacy");
var _NotificationsIcon2 = require("./NotificationsIcon.modern");
// Flag-gated UI: `NotificationsIcon.legacy` is the component as it is on
// master, `NotificationsIcon.modern` the ui-charts-update rewrite. The navbar
// sits under the root UiDesignProvider, so ENABLE_MODERN_UI (or the user's
// interface choice) decides which one renders.
var NotificationsIcon = exports.NotificationsIcon = (0, _uiSwitch.uiSwitch)(_NotificationsIcon.NotificationsIcon, _NotificationsIcon2.NotificationsIcon, "NotificationsIcon");